<template>

<div class="container">
    <h1><font-awesome-icon icon="home" /> Home -  <a href="#">Exam</a>
    
    <div class="float-right" style="margin-top: -62px;">


  <b-button v-b-modal.modal-lg v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button>


  <b-modal id="modal-lg" size="lg" title="Exam">
   
  <div class="panal2">
    <div>
      
      <div class="panal-header2"> {{ info.PageName }}</div>
     <div class="panal-body2">

  <div v-html="info.PageDescription"></div>
      </div>
     </div>

  

  </div>


  </b-modal>


</div>
    
    
    
    
    </h1>

<div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Exam </div>
<div class="panal-body">


<div class="table-responsive">

    <table class="table mt-3 table-bordered">
    <thead class="thead-light">
        <tr>
            <th></th>
        <th scope="col">Exam Name</th>
        <th scope="col">Exam Type</th>
        <th scope="col">Location</th>
        
        <th scope="col">Exam Date</th>
        <th scope="col">Exam Time From</th>
        <th scope="col">Exam Time TO</th>
        
        
        <th scope="col">Equivalent Exam</th>
        <th scope="col">Result</th>
      <td scope="col">Action</td>
   
      
        </tr>
    </thead>
    <tbody >
        <tr v-if="empty"> <td colspan="12"> No Exam  </td></tr>
        <tr v-else v-for="(exam,index) in ExamList" v-bind:key="exam.serial">
        <td scope="row">{{index+1}}</td>
        <td>{{exam.ExamNameEN}}</td>
          <td>{{exam.ExamType}}</td>
        <td>{{exam.Location}}</td>
      
        <td>{{exam.ExamDate}}</td>
        <td>{{exam.ExamTimeFrom}}</td>
        <td>{{exam.ExamTimeTo}}</td>
        <td>{{exam.EquivalentExam}}</td>
        <td>{{exam.ReusltTitle}}</td>
        <td>    
            
                        <button type="button" class="btn btn-primary mr-1" v-if="exam.BookingFlag == 1" @click="ShowBookExam(exam.serial , exam.ExamID)">Book Exam</button>
                        <button type="button" class="btn btn-info mr-1" v-if="exam.CancelInCampusFlag == 1" @click="CancelinCampusExam(exam.serial)"  >Have Certification</button>
<button type="button" class="btn btn-primary mr-1" v-else-if="exam.TypeFlag == 1" @click="showExam(exam.serial)">Choose Type</button>
<button type="button" class="btn btn-success" v-if="exam.RetryFlag == 1 " @click="showtryagain">Another Try</button>
<button type="button" class="btn btn-success" v-if="exam.EquivalentFlag == 1 " @click="showEquivilant(exam.serial)">Upload Certificate</button>
<button type="button" class="btn btn-success" v-if="exam.ChangeTypeFlag == 1 " @click="showUpdateType(exam.serial)">Change Exam type</button>
<span v-if="exam.BookingFlag ==0 && exam.RetryFlag ==0 && exam.EquivalentFlag == 0 && exam.ChangeTypeFlag ==0  && exam.TypeFlag ==0"> no action </span>
        </td>
   
        </tr>
 
    
    </tbody>
    </table>
    <div class="mt-10 col-6 ml-auto mr-auto">
 <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'"  >{{message}}  <router-link to="wallet" class="pull-right" v-if="successful">Open Wallet</router-link></div>

    </div>

</div>

<div class="text-right">
    

</div>

  <b-modal id="modal-confirm" size="lg" centered  title="Cancel incampus exam" @ok="onModalOk">
   
  <div class="panal2">
    <div>
      
      <div class="panal-header2"> Are You Sure ? </div>
     <div class="panal-body2">

  <div ><p>Are you sure you want to cancel inCampus exam and upload an equivalent certificate  </p>
  <strong class="text-danger">This Action can't be reversed</strong>
    
  </div>
      </div>
     </div>

  

  </div>


  </b-modal>




</div>

</div>

<ExamType v-if="chooseType != 0 || chooseType == 'undefined' " @clicked="viewEquilvilant"/>
<BookExam v-if="book != 0 || book == 'undefined'" @clicked="cancelaftersubmit"/>
<UploadCerti v-if="equivilant != 0 || equivilant == 'undefined'"  @clicked="cancelaftersubmit" />

<UpdateCertificate v-if="updateEquivilant != 0 || updateEquivilant == 'undefined'"  @clicked="cancelaftersubmit" />

<AnotherExam v-if="anotherTry != 0 || anotherTry == 'undefined'" @clicked="cancelaftersubmit"/>

<UpdateExamType v-if="UpdateType != 0 || UpdateType == 'undefined'" @clicked="cancelaftersubmit"/>
</div>
</div>
</div>



</template>

<script>

import ExamType from "../../components/Applicant/ExamType";
import UpdateExamType from "../../components/Applicant/UpdateExamType";
import BookExam from "../../components/Applicant/BookExam";
import UploadCerti from "../../components/Applicant/UploadCerti";
import UpdateCertificate from '../../components/Applicant/update_UploadCerti'
import AnotherExam from "../../components/Applicant/AnotherExam";
import ApplicantDataServices from '../../services/Applicant/ApplicantData.services';
import ApplicantService from '../../services/Applicant/Applicant.service';



export default {

  components: {
 ExamType, BookExam, UploadCerti, AnotherExam , UpdateCertificate,UpdateExamType
  },
  data(){
      return{
          info: '',
          book:0,
          equivilant:0,
          anotherTry:0,
          updateEquivilant:0,
          chooseType:0,
          UpdateType:0,
          ExamList:[],
          empty:false,
          message:'',
          successful:'',
          examSerial : ''
      }
  },
  computed:{
 currentUser(){
     return this.$store.state.auth.user
 }
  },
  mounted() {
         let id = 4;
 ApplicantService.GetHelpPages(id).then(response => {
        this.info = response.data
      });

    this.GetAllApplicantExam()
  },
  methods:{
       gotoWallet() {
            this.$router.push('wallet')
        },

      showExam(serial){
          this.chooseType= 1
          localStorage.setItem('examId',serial)
      },
      showUpdateType(examID){
                   localStorage.setItem('examId',examID)
 this.cancelaftersubmit()
 this.UpdateType = 1

      },
      viewEquilvilant(value){
     
          if(value == 1){
             this.book = 0 
             this.equivilant = 0
             this.successful =true
             this.message = " Your Exam Updated Successfully Kindly Check your Wallet to View your Charges"
                 this.GetAllApplicantExam()

          }else if (value == 3){
               this.book = 0
              this.equivilant = 1
                  this.GetAllApplicantExam()

             
          }else{
                  

             this.cancelaftersubmit()
             
          }
      },
      ShowBookExam(serial,ExamiD){
          this.book = 1 
          localStorage.setItem('examSerial',serial)
          localStorage.setItem('ExamID',ExamiD)
      },
      showtryagain(){
          this.anotherTry = 1
      },
      showEquivilant(ExamID){

                    localStorage.setItem('examId',ExamID)
this.cancelaftersubmit()
this.updateEquivilant = 1
      },
      cancelaftersubmit(){
        this.book =0 ;
        this.equivilant=0
        this.anotherTry=0
        this.chooseType =0
        this.updateEquivilant = 0 
        this.UpdateType = 0
        this.GetAllApplicantExam()
      },
      GetAllApplicantExam(){
            ApplicantDataServices.GetApplicantQualificationExams(this.currentUser.UserIDSerial).then(Response =>{
          this.ExamList=Response.data

        }, error => {
              this.successful = false
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                if(error.response.status == 404) this.message =''
            });
      },
      CancelinCampusExam(serial){
          this.examSerial = serial
          this.$bvModal.show('modal-confirm')
          this.cancelaftersubmit()
               
      },
      onModalOk(){
         
          ApplicantDataServices.CancelinCampusExam(this.examSerial,this.currentUser.UserIDSerial).then(() =>{
             
              this.$bvModal.hide('modal-confirm')
              this.GetAllApplicantExam()
          })
      }
  },
 
};



</script>

<style scoped>

.help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}

h1{
    color:#285475;
    font-size:25px;
    border-bottom:1px #646464 dashed;
    padding:10px 0px;
}
h1 a{
    color:#ff8600;
}
table tr th {
    background-color: #4caf5000 !important;
    color:#333;
    font-weight:bold;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}
.app-stu-photo{
    float:right;
    width:200px;
    border-radius:10px;
    border:1px solid #111;
    margin-top:20px;
}
.app-stu-photo img{
    width:100%;
      border-radius:10px;
      
}
.app-All{
    width:80%;
    float:left;
}
.app-stu{
    border-bottom:1px #333 dotted;
    padding:10px 0px;

}
.app-stu .title{
    font-weight:bold;

}

.app-stu .title span{
    font-weight: 100;


    
}

.table .thead-light th {

    font-size: 14px !important;
}

.panal2{
  background:#eee;
  border-radius:10px;
color:#333;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;


}
.panal-header2{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2{
    padding:20px;
    color:#333;
}
.mt-10{
    margin-top: 10px;
}

.btn{
    margin-left: 5px;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
</style>